import { atom } from 'jotai';
import { createRequestAtom } from '../../../shared/utils/request-atom';
import { WAGroupMetaDataResponse } from '../typings/groups';

export const isCreateGroupModalOpenAtom = atom<boolean>(false);

export const waGroupMetadataAtom = createRequestAtom<WAGroupMetaDataResponse>();
